import Debug from 'debug';
import { AuthenticatedApiService } from '../services/AuthenticatedApi';
import { urls } from './transcript';

export type InsertedVideoInterface = {
  type: 'basic';
  ok: boolean;
  id: string;
  subtitle: string;
  transcript?: string;
  title: string;
};

type DetailedInsertVideoInterface = {
  type: 'detailed';
  ok: boolean;
  id: string;
  subtitle: string;
  transcript?: string;
  title: string;
  user_id: string;
  alt_text: string;
  video_urls: Record<string, string>;
  animated: string;
  thumb_id: string;
  thumb_url: string;
  animated_thumb_url: string;
  available_thumbnail_urls: Record<string, string>;
  use_animated_thumbnail: boolean;
  true_thumbnail_url: string;
  thumb_url_orig: string;
  thumb_switch_url: string;
  using_custom_thumb: string;
  no_logo: string;
  short_url: string;
  play_button_pos: string;
  height: string;
  width: string;
  duration: string;
  encoder_key: string;
  video_input_method: string;
  upload_date: string;
  updated_date: string;
  available_formats: string[];
  original_video_url: string;
  original_width: string;
  original_height: string;
  original_filename: string;
  original_video_codec: string;
  original_audio_codec: string;
  cdn_video_id: string;
  heatmap_do_not_proc: string;
  hosting_partner: string;
  userFirstName: string;
  userLastName: string;
  userEmailAddress: string;
  clientName: string;
  details: {
    details: {
      name: string;
      duration: number;
      userId: string;
      thumbnailUrl: string;
      uploadDate: string;
    };
    totalViews: number;
    totalHeatmaps: number;
    last24HoursViews: number;
    shares: Record<string, number>;
    views: unknown[];
    viewsByDevice: Record<string, number>;
    viewsByDay: unknown[];
  };
  full_url: string;
  useAnimatedGif: boolean;
  trueThumbnailUrl: string;
};

type GetVideoDetailsOptions = {
  detailed: boolean;
  fixThumbnail: boolean;
};

const defaultGetVideoDetailsOptions: GetVideoDetailsOptions = {
  detailed: false,
  fixThumbnail: false,
};

/**
 * Get video details from the API
 */
export async function getVideoDetails(
  api: AuthenticatedApiService,
  videoId: string,
  options: Partial<GetVideoDetailsOptions> = {},
): Promise<InsertedVideoInterface | DetailedInsertVideoInterface> {
  const debug = Debug('o365:lib:transcript:getVideoDetails');

  const fullOptions = {
    ...defaultGetVideoDetailsOptions,
    ...options,
  };

  const url = new URL(`/v2/videos/${videoId}`, urls.apiUrl);

  // add optional params
  if (fullOptions.detailed) {
    url.searchParams.set('detailed', '1');
  }
  if (fullOptions.fixThumbnail) {
    url.searchParams.set('fixThumbnail', '1');
  }

  const response = await api.get(url);

  if (!response) {
    debug('response error');
    // handle error
    return {
      type: 'basic',
      ok: false,
      id: videoId,
      subtitle: videoId,
      title: videoId,
    };
  }

  const result = await response.json();
  debug(' response success');

  if (!fullOptions.detailed && !fullOptions.fixThumbnail) {
    return {
      type: 'basic',
      ok: true,
      id: videoId,
      subtitle: result.name,
      title: result.name,
    };
  }
  return {
    // add the raw JSON data
    ...result,
    // then correct/override with our data
    type: 'detailed',
    ok: true,
    id: videoId,
    subtitle: result.name,
    title: result.name,
  };
}
